module.exports = __webpack_public_path__ + "static/media/valor4_3_2.be4c07b8.png";